import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import TextField from '@material-ui/core/TextField';
import { Text } from 'recharts';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';
import ResetPassDialog from './ResetPassDialog';
import ValidationText from '../atoms/ValidationText';

const styles = {};

const enhance = compose(
  withState('typeReset', 'setTypeReset', '1'),
  withState('openConfirm', 'setOpenConfirm', false),
  withState('newpass', 'setNewpass', ''),
  withState('errorMessage', 'setErrorMessage', '')
);

const Main = enhance(
  ({
    openDelete,
    updateOpenDelete,
    params,
    onClickAction,
    typeReset,
    setTypeReset,
    openConfirm,
    setOpenConfirm,
    newpass,
    setNewpass,
    errorMessage,
    setErrorMessage
  }) => {
    const cancelAction = () => {
      updateOpenDelete(false);
      setTypeReset(null);
    };
    const cancelConfirm = () => setOpenConfirm(false);
    const deleteAction = paramDelete => {
      updateOpenDelete(false);
      setOpenConfirm(false);
      if (typeReset === '1') {
        onClickAction(paramDelete, typeReset, newpass);
      } else if (typeReset === '2') {
        if (!newpass) {
          setErrorMessage('必須項目です。');
        }
        onClickAction(paramDelete, typeReset, newpass);
      }
    };

    const valid = e => {
      const value = e.toString();
      if (value === '') {
        setErrorMessage('必須項目です。');
        return 1;
      }
      if (value.length > 50) {
        setErrorMessage('パスワードは50文字未満である必要があります');
        return 1;
      }
      if (
        value.length < 8 ||
        !/[A-Z]/.test(value) ||
        !/[a-z]/.test(value) ||
        !/[0-9]/.test(value)
      ) {
        setErrorMessage(
          '英大文字・英小文字・数字全てを含め、8文字以上で入力してください。'
        );
        return 1;
      }
      setErrorMessage('');
      return 0;
    };

    const updateRadio = value => {
      setTypeReset(value);
    };

    const changeActionConfirm = () => {
      if (typeReset === '2' && !newpass) {
        setErrorMessage('必須項目です。');
      } else if (
        (typeReset === '2' && newpass && !valid(newpass)) ||
        typeReset === '1'
      ) {
        setOpenConfirm(true);
      }
    };
    return (
      <div>
        <Dialog
          open={openDelete}
          onClose={() => {
            updateOpenDelete(false);
            setTypeReset(null);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <RadioGroup
              value={typeReset}
              onChange={e => {
                updateRadio(e.target.value);
              }}
            >
              <div>
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" />}
                  label="パスワードリセット"
                />
              </div>
              <div>
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary" />}
                  label="パスワード変更"
                />
              </div>
            </RadioGroup>
            {typeReset === '2' && (
              <>
                <TextField
                  required
                  label=""
                  placeholder=""
                  fullWidth
                  margin="normal"
                  onChange={e => {
                    setNewpass(e.target.value);
                  }}
                  onBlur={e => {
                    valid(e.target.value);
                  }}
                />
                <Text
                  style={{
                    fontSize: 12,
                    fontWeight: 500,
                    lineHeight: '18px',
                    color: '#333'
                  }}
                >
                  パスワードは英大文字・英小文字・数字の３種類全てを含め、8文字以上で設定してください。
                </Text>
                <ValidationText message={errorMessage} />
              </>
            )}
          </DialogContent>
          <DialogActions>
            <CancelButton onClickAction={cancelAction} color="default" />
            <ChangeButton onClickAction={changeActionConfirm} />
          </DialogActions>
        </Dialog>
        <ResetPassDialog
          openDelete={openConfirm}
          updateOpenDelete={setOpenConfirm}
          cancelAction={cancelConfirm}
          deleteAction={() => deleteAction(params)}
          target="メニュー"
        />
      </div>
    );
  }
);

export default withStyles(styles)(Main);
